import type { PosSettings, ReceiptData } from '@/types';

export function showReceiptDiscountPrint(posSettings?: PosSettings | null): boolean {
  return !posSettings || posSettings.show_discount_in_invoice_print !== false;
}

export function receiptPromoTotals(
  inv: Pick<ReceiptData, 'item_total' | 'service_total' | 'promo_total'> | null | undefined,
) {
  const charged = (Number(inv?.item_total) || 0) + (Number(inv?.service_total) || 0);
  const promo = Number(inv?.promo_total) || 0;
  return { charged, promo, original: charged + promo };
}

export function receiptLinePromo(item: {
  quantity?: number;
  rate?: number;
  amount?: number;
  original_rate?: number;
  promo_amount?: number;
}) {
  const qty = Number(item.quantity) || 0;
  const chargedAmount = Number(item.amount) || 0;
  const chargedRate = Number(item.rate) || 0;
  const promoAmount = Number(item.promo_amount) || 0;
  const storedOriginalRate = Number(item.original_rate) || 0;
  const originalAmount = promoAmount > 0
    ? chargedAmount + promoAmount
    : storedOriginalRate > 0 && qty
      ? storedOriginalRate * qty
      : chargedAmount;
  const originalRate = storedOriginalRate > 0
    ? storedOriginalRate
    : qty
      ? originalAmount / qty
      : chargedRate;
  const hasPromo = promoAmount > 0.004 && originalAmount - chargedAmount > 0.004;
  return {
    chargedRate,
    chargedAmount,
    originalRate,
    originalAmount,
    promoAmount,
    hasPromo,
  };
}
